import request from "@/utils/request"


/**
 * 获取材料Pagelist
 * @param {*} data 
 * @returns 
 */
export function getScanMaterialListApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/GetScanMaterialList",
    method: "post",
    data
  })
}


/**
 * 新增材料
 * @param {*} data 
 * @returns 
 */
export function addScanMaterialApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/AddScanMaterial",
    method: "post",
    data
  })
}


/**
 * 修改材料
 * @param {*} data 
 * @returns 
 */
export function updateScanMaterialApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/UpdateScanMaterial",
    method: "post",
    data
  })
}


/**
 * 删除材料
 * @param {*} data 
 * @returns 
 */
export function deleteScanMaterialApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/DeleteScanMaterial",
    method: "post",
    data
  })
}



/**
 * 获取查勘项目pagelist
 * @param {*} data 
 * @returns 
 */
export function getScanProjectListApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/GetScanProjectList",
    method: "post",
    data
  })
}


/**
 * 新增查勘项目
 * @param {*} data 
 * @returns 
 */
export function addScanProjectApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/AddScanProject",
    method: "post",
    data
  })
}


/**
 * 修改查勘项目
 * @param {*} data 
 * @returns 
 */
export function updateScanProjectApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/UpdateScanProject",
    method: "post",
    data
  })
}


/**
 * 删除查勘项目
 * @param {*} data 
 * @returns 
 */
export function deleteScanProjectApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/DeleteScanProject",
    method: "post",
    data
  })
}




/**
 * 获取点位pagelist
 * @param {*} data 
 * @returns 
 */
export function getScanProjectItemListApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/GetScanProjectItemList",
    method: "post",
    data
  })
}


/**
 * 获取点位Tree
 * @param {*} data 
 * @returns 
 */
export function getScanProjectItemTreeApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/GetScanProjectItemTree",
    method: "post",
    data
  })
}


/**
 * 新增点位
 * @param {*} data 
 * @returns 
 */
export function addScanProjectItemApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/AddScanProjectItem",
    method: "post",
    data
  })
}


/**
 * 修改点位
 * @param {*} data 
 * @returns 
 */
export function updateScanProjectItemApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/UpdateScanProjectItem",
    method: "post",
    data
  })
}


/**
 * 删除点位
 * @param {*} data 
 * @returns 
 */
export function deleteScanProjectItemApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/DeleteScanProjectItem",
    method: "post",
    data
  })
}


/* ===================== 项目类型管理（4.1 本次新增） ===================== */

export function getScanProjectTypeListApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/GetScanProjectTypeList",
    method: "post",
    data
  })
}

export function addScanProjectTypeApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/AddScanProjectType",
    method: "post",
    data
  })
}

export function updateScanProjectTypeApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/UpdateScanProjectType",
    method: "post",
    data
  })
}

export function deleteScanProjectTypeApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/DeleteScanProjectType",
    method: "post",
    data
  })
}


/* ===================== 项目统计（4.3 统计区） ===================== */

export function getScanProjectStatApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/GetScanProjectStat",
    method: "post",
    data
  })
}


/* ===================== 点位材料施工（4.6） ===================== */

export function getScanProjectItemMaterialListApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/GetScanProjectItemMaterialList",
    method: "post",
    data
  })
}

export function addScanProjectItemMaterialApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/AddScanProjectItemMaterial",
    method: "post",
    data
  })
}

export function updateScanProjectItemMaterialApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/UpdateScanProjectItemMaterial",
    method: "post",
    data
  })
}

export function deleteScanProjectItemMaterialApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Scan/DeleteScanProjectItemMaterial",
    method: "post",
    data
  })
}


